module.exports = __webpack_public_path__ + "static/opening2-d5b5f3d24ae198efedcf9288cbe7062f.jpg";